import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Popup, Toast } from "antd-mobile";
import { CloseOutline } from "antd-mobile-icons";
import styles from "./index.module.scss";
import rescueSubmitImage from "../assets/rescue_submit.png";
import waitingRescueImage from "../assets/waiting_rescue.png";
import { cancelRescue, queryRescueOrderList } from "../common/js/request";
import SelectItem from "../components/SelectItem";
import {
  cancelTip,
  defaultRescueTextData,
  RESCUE_STATE_TEXT_MAP,
  CANCEL_REASONS,
  RESCUE_STATE,
} from "../common/js/constant";
import { useHistory } from "react-router-dom";

const RescueStatusPage: React.FC = () => {
  const [statusData, setStatusData] = useState<any>({});
  const [statusText, setStatusText] = useState("");
  const [tipText, setTipText] = useState("");
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [showCancelButton, setShowCancelButton] = useState(false);
  const history = useHistory();
  const timeRef = useRef<any>(null);

  const bgImage = useMemo(() => {
    const code = statusData.statusCode;
    switch (code) {
      case RESCUE_STATE.rescuing:
        return waitingRescueImage;
      default:
        return rescueSubmitImage;
    }
  }, [statusData.statusCode]);

  useEffect(() => {
    document.title = "在线救援";

    // 每隔30秒请求一次救援状态接口
    const queryRescueStatus = () => {
      if (timeRef.current) {
        clearTimeout(timeRef.current);
        timeRef.current = null;
      }
      fetchRescueStatus();
      timeRef.current = setTimeout(() => {
        queryRescueStatus();
      }, 30000);
    };

    queryRescueStatus();

    return () => {
      if (timeRef.current) {
        clearTimeout(timeRef.current);
        timeRef.current = null;
      }
    };
  }, []);

  const fetchRescueStatus = async () => {
    try {
      const res = await queryRescueOrderList();
      const data = res?.data?.[0];
      if (data) {
        const isCancel = data.cancelApply === 1;
        const textData =
          RESCUE_STATE_TEXT_MAP[data.statusCode] ?? defaultRescueTextData;

        setStatusData(data);
        setStatusText(textData.title);
        setShowCancelButton(!isCancel);
        setTipText(isCancel ? cancelTip : textData.tip);
      } else {
        setTipText("未查询到救援订单");
        history.replace("/home-new");
      }
    } catch (error) {
      setTipText("救援状态获取失败");
    }
  };

  const handleCancelClick = () => {
    setShowCancelPopup(true);
  };

  const handleClosePopup = () => {
    setShowCancelPopup(false);
  };

  const handleCancelConfirm = async () => {
    if (!cancelReason) {
      Toast.show("请选择取消原因");
      return;
    }

    try {
      await cancelRescue({
        cancelReason,
        orderNumber: statusData.orderNumber,
      });

      Toast.show("提交成功");
      setShowCancelPopup(false);
      setShowCancelButton(false);
      setTipText(cancelTip);
    } catch (error) {
      Toast.show("提交失败，请重试");
    }
  };

  return (
    <div className={styles.container}>
      <img src={bgImage} alt="等待中" className={styles.image} />
      {(statusText || tipText) && (
        <>
          <div className={styles.status}>{statusText}</div>
          <div className={styles.tip}>{tipText}</div>
          {showCancelButton && (
            <Button className={styles.cancelButton} onClick={handleCancelClick}>
              取消救援
            </Button>
          )}
        </>
      )}

      <Popup
        visible={showCancelPopup}
        onMaskClick={handleClosePopup}
        position="bottom"
        destroyOnClose={false}
      >
        <div className={styles.cancelPopup}>
          <div className={styles.popupHeader}>
            <div className={styles.popupTitle}>选择取消救援原因</div>
            <div className={styles.closeIcon} onClick={handleClosePopup}>
              <CloseOutline />
            </div>
          </div>
          <div className={styles.reasonList}>
            {CANCEL_REASONS.map((reason) => (
              <SelectItem
                key={reason.value}
                title={reason.label}
                selected={cancelReason === reason.value}
                onClick={() => setCancelReason(reason.value)}
              />
            ))}
          </div>
          <div className={styles.confirmButtonContainer}>
            <Button
              className={styles.confirmButton}
              onClick={handleCancelConfirm}
            >
              确认
            </Button>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default RescueStatusPage;
